import currentUserData from './CurrentUserData'

export default {
    currentUserData
};